import { isProdEnv } from "utils/utils";

function mappedOriginUrls() {
  const urlMappings = process.env.REACT_APP_ORIGIN_MAPPING;
  if (urlMappings == null) {
    return isProdEnv()
      ? {}
      : {
        'http://venue:8000': 'http://localhost:8002',
        'http://localstack:4566': 'http://localhost:4566',
      };
  }
  return JSON.parse(urlMappings);
}

function getMappedUrl(urlString: string) {
  const urls = mappedOriginUrls();

  const url = new URL(urlString);

  if (!(url.origin in urls)) {
    return urlString;
  }

  const newOrigin = urls[url.origin];
  const urlPath = urlString.slice(url.origin.length, urlString.length).replace(/^\/+/, '');

  if (urlPath.length === 0 || urlPath === '/') {
    return newOrigin;
  }
  return `${newOrigin}/${urlPath}`;
}

function getCognitoDetailsFromConfigBootstrap(data: any) {
  // function to return object containing cognito details from strings provided from bootstrap endpoint.
  const issuerStr = data.issuer;
  const userPoolStrIndex = issuerStr.lastIndexOf('/');
  const cognitoUserPoolID = issuerStr.slice(userPoolStrIndex + 1);
  const cognitoDomain = new URL(data.logout_uri).host;
  const cognitoRegion = cognitoUserPoolID.substring(0, cognitoUserPoolID.indexOf('_'));
  return { cognitoUserPoolID, cognitoDomain, cognitoRegion };
}

// reducer to encapsulate ILS application config that will be stored in react globol config.
// so it can be accessed by components and non component functions
const configReducer = (state: any, action: any): any => {
  const { data } = action;

  switch (action.type) {
    case 'BOOTSTRAP': {
      const { cognitoUserPoolID, cognitoDomain, cognitoRegion } =
        getCognitoDetailsFromConfigBootstrap(data);

      return {
        ...state,
        COGNITO_CLIENT_ID: data.client_id,
        COGNITO_REGION: cognitoRegion,
        COGNITO_USERPOOL_ID: cognitoUserPoolID,
        COGNITO_DOMAIN: cognitoDomain,
      };
    }

    case 'LOCAL': {
      return {
        ...state,
        DATA_API_URL: getMappedUrl(data.DATA_API_URL),
        CONFIG_API_URL: getMappedUrl(data.CONFIG_API_URL),
      };
    }

    case 'SYSTEM_SERVICES': {
      return {
        ...state,
        HELP_URL: getMappedUrl(data.HELP_URL),
        VENUE_API_URL: getMappedUrl(data.VENUE_API_URL),
      };
    }

    case 'AUTHENTICATION': {
      return {
        ...state,
        SHOULD_USE_COGNITO: data.SHOULD_USE_COGNITO,
      };
    }

    default:
      throw new Error();
  }
};

export default configReducer;
